import { html, css } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { BaseVisualization, ReportEvent, VisualizationOptions } from "./baseVisualization";
import type { ContextData } from "@reporting/rp-types/analytics";
import { ReportResult } from "../../model";

@customElement('rp-visual-tile')
export class TileVisualization extends BaseVisualization {

	static styles = css`
		:host, div.body {
			display: block;
			width: 100%;
			height: 100%;
			position: relative;
		}
	`;

	@query('div.body')
	body: HTMLDivElement;

	@property({type: Object})
	result: ReportResult;

	@state()
	empty = false;

	refresh(contextData?: ContextData) {
		super.refresh(contextData);
		this.runScripts();
		this.dispatchEvent(new ReportEvent('load'));
	}

	updated() {
		this.refresh();
	}

	render = () => html`
		<div class="body">sss</div>
	`;

	layout() { }

}
